import * as React from "react"
import type { SVGProps } from "react"
const SvgArrowDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M13 16.47V5.29a1 1 0 0 0-.28-.72A1 1 0 0 0 12 4.3a1 1 0 0 0-.72.28 1 1 0 0 0-.28.72v11.18l-4.9-4.9a1 1 0 0 0-.7-.3q-.4.02-.7.32-.28.3-.29.7t.29.7l6.6 6.6q.14.15.32.21t.38.07.37-.07a1 1 0 0 0 .33-.2L19.3 13a1 1 0 0 0 .27-.69 1 1 0 0 0-.28-.71 1 1 0 0 0-.7-.3q-.42 0-.72.3z" />
  </svg>
)
export default SvgArrowDown
